'use es6';

const ANALYTICS = 'analytics';
const ADVERTISEMENT = 'advertisement';
const FUNCTIONALITY = 'functionality';
export const ANALYTICS_COOKIE_ID = 1;
export const ADVERTISEMENT_COOKIE_ID = 2;
export const FUNCTIONALITY_COOKIE_ID = 3;
export const cookieIdToKey = {
  [ANALYTICS_COOKIE_ID]: ANALYTICS,
  [ADVERTISEMENT_COOKIE_ID]: ADVERTISEMENT,
  [FUNCTIONALITY_COOKIE_ID]: FUNCTIONALITY
};
export default class Consent {
  constructor(allowed, categories, previousCategories) {
    this.allowed = allowed;
    if (!previousCategories) {
      this.previousCategories = {
        necessary: true,
        analytics: false,
        advertisement: false,
        functionality: false
      };
    } else {
      this.previousCategories = previousCategories;
    }
    if (!categories) {
      this.categories = {
        necessary: true,
        analytics: allowed,
        advertisement: allowed,
        functionality: allowed
      };
    } else {
      this.categories = categories;
    }
  }
  allCategoriesSelected() {
    return this.categories.necessary && this.categories.analytics && this.categories.advertisement && this.categories.functionality;
  }
  getSafeCopy() {
    return new Consent(this.allowed, {
      necessary: this.categories.necessary,
      analytics: this.categories.analytics,
      advertisement: this.categories.advertisement,
      functionality: this.categories.functionality
    }, {
      necessary: this.previousCategories.necessary,
      analytics: this.previousCategories.analytics,
      advertisement: this.previousCategories.advertisement,
      functionality: this.previousCategories.functionality
    });
  }
  toCookieString() {
    return `${ANALYTICS_COOKIE_ID}:${this.categories.analytics},${ADVERTISEMENT_COOKIE_ID}:${this.categories.advertisement},${FUNCTIONALITY_COOKIE_ID}:${this.categories.functionality}`;
  }
  static buildFromCookieString(cookie) {
    const cookieParts = cookie.split(',');
    const categories = {
      necessary: true,
      analytics: false,
      advertisement: false,
      functionality: false
    };
    cookieParts.forEach(cookiePart => {
      const categoryParts = cookiePart.split(':');
      if (categoryParts.length !== 2) {
        return;
      }
      const categoryCookieId = categoryParts[0];
      const category = cookieIdToKey[categoryCookieId];
      if (!category) {
        return;
      }
      categories[category] = categoryParts[1] === 'true';
    });
    const allowed = categories.necessary && categories.advertisement && categories.analytics && categories.functionality;
    return new Consent(allowed, categories);
  }
  static buildInitialConsent() {
    const categories = {
      necessary: true,
      analytics: false,
      advertisement: false,
      functionality: false
    };
    return new Consent(false, categories);
  }
}